






























































import { EventType } from '@/constants';
import { HomeCareVideos, Slide } from '@/types';
import { defaultHomeImage } from '@/util';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'imageSlider',
  data () {
    return {
      position: 0,
      timers: null as any,
      mount: false,
      panelWidth: 0,
      imageHeight: '0px',
      slides: [] as any
    };
  },
  props: {
    isHomeCareVideo: {
      type: Boolean,
      default: false
    },
    lazyload: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: () => [] as any
    },
    videos: {
      type: Array,
      default: () => [] as any
    },
    index: {
      type: Number,
      default: 0
    },
    slide: {
      type: Object as PropType<Slide>,
      default: () => {
        return {
          enable: false,
          mouseHover: false,
          timestamp: 5000
        };
      }
    },
    paginate: {
      type: Boolean,
      default: false
    },
    photoSection: {
      type: Boolean,
      default: false
    }
  },
  beforeMount () {
    this.slides = this.isHomeCareVideo ? this.videos : this.images;
    this.currentPostion = this.index;
    this.isSlidingEnable();
    this.mount = true;
  },
  mounted () {
    this.$emit('updateSelectPagination', 0);
    this.panelWidth = (document.querySelector(`#${this.panelId}`) as HTMLDivElement).clientWidth;
  },
  computed: {
    hideFirstArrow (): boolean {
      return this.isHomeCareVideo ? (this.videos.length === 1 || this.ifFirst) : this.photoSection && (this.images.length === 1 || this.ifFirst);
    },
    panelId (): string {
      return `${this.isHomeCareVideo ? 'video' : 'photo'}-panels`;
    },
    hideLastArrow (): boolean {
      return this.isHomeCareVideo ? (this.videos.length === 1 || this.ifLast) : this.photoSection && (this.images.length === 1 || this.ifLast);
    },
    styleObject (): any {
      return {
        width: `${this.totalWidth}px`,
        transform: `translate3d(-${this.panelWidth * this.position}px, 0px, 0px)`
      }
    },
    totalWidth (): number {
      return this.slides.length * this.panelWidth;
    },
    getTranslateStyle (): string {
      return `
        width: ${this.totalWidth}px,
        transform: translate3d(-${this.panelWidth * this.position}px, 0px, 0px);` || '';
    },
    before (): string {
      return this.isHomeCareVideo ? (this.slides[this.calculatePosition(this.position - 1)] as HomeCareVideos).videoUrl : this.slides[this.calculatePosition(this.position - 1)] as string;
    },
    after (): string {
      return this.isHomeCareVideo ? (this.slides[this.calculatePosition(this.position + 1)] as HomeCareVideos).videoUrl : this.slides[this.calculatePosition(this.position + 1)] as string;
    },
    current (): string {
      return this.isHomeCareVideo ? (this.slides[this.calculatePosition(this.position)] as HomeCareVideos).videoUrl : this.slides[this.calculatePosition(this.position)] as string;
    },
    ifLast (): boolean {
      return this.position === this.slides.length - 1;
    },
    ifFirst (): boolean {
      return this.position === 0;
    },
    currentPostion: {
      get (): number {
        return this.position;
      },
      set (current: number): void {
        this.position = Math.abs(current) % (this.isHomeCareVideo ? this.videos.length : this.images.length);
      }
    }
  },
  updated () {
    this.getImageHeight();
  },
  created () {
    window.addEventListener('resize', this.myEventHandler);
  },
  destroyed () {
    window.removeEventListener('resize', this.myEventHandler);
  },

  methods: {
    loaded () {
      this.getImageHeight();
    },
    getImageHeight () {
      const img = new Image();
      img.src = this.slides[this.currentPostion] as string;
      img.onerror = () => {
        const image = new Image();
        image.src = defaultHomeImage()
        image.onload = () => {
          this.imageHeight = `${image.naturalHeight.toString()}px`;
        }
      }
      img.onload = () => {
        const height = (document.getElementById('current' + this.currentPostion)?.offsetHeight as number);
        this.imageHeight = `${height}px`;
      }
    },
    onImageError (event: Event) {
      (event.target as HTMLImageElement).src = defaultHomeImage();
    },
    myEventHandler (e: any) {
      this.panelWidth = (document.querySelector(`#${this.panelId}`) as HTMLDivElement).clientWidth;
    },
    isSlidingEnable () {
      if (this.slide && this.slide.enable) {
        this.startRotation(this.slide.timestamp);
      }
    },
    startRotation (timeStamp: number) {
      this.stopRotation();
      this.timers = setInterval(this.next, timeStamp);
    },
    stopRotation: function () {
      clearTimeout(this.timers);
      this.timers = null;
    },
    updateIndex: function (index: number) {
      const iFrame = document.querySelector('#iframe-' + this.position);
      if (iFrame) {
        iFrame.setAttribute('src', iFrame.getAttribute('src')!);
      }
      this.position = index;
    },
    calculatePosition (value: number): number {
      const length = this.slides.length;
      if (value < 0) {
        value = length + value;
      }
      if (value === 0) {
        return 0;
      }
      return Math.abs(value) % length;
    },
    next: function () {
      const iFrame = document.querySelector('#iframe-' + this.position);
      if (iFrame) {
        iFrame.setAttribute('src', iFrame.getAttribute('src')!);
      }
      if (this.lazyload && this.position > this.slides.length - 3) {
        this.$emit(EventType.INFINITE_LOAD);
      }
      if (this.ifLast && this.slide.enable) {
        this.stopRotation();
      } else if (!this.ifLast) {
        this.currentPostion = this.position + 1;
        this.$emit('updateSelectPagination', this.currentPostion);
        this.isSlidingEnable();
      }
    },
    prev: function () {
      console.log(this.position, this.currentPostion);
      const iFrame = document.querySelector('#iframe-' + this.position);
      if (iFrame) {
        iFrame.setAttribute('src', iFrame.getAttribute('src')!);
      }
      if (!this.ifFirst) {
        this.currentPostion = this.position - 1;
        this.$emit('updateSelectPagination', this.currentPostion);
        this.isSlidingEnable();
      }
    }
  },
  watch: {
    index () {
      if (this.index >= 0 && this.slides.length > this.index) {
        this.currentPostion = this.index;
      }
    },
    position (value: number) {
      this.$emit(EventType.UPDATE_IMAGE_POSITION, value)
    }
  }
});
